module.exports = "<form class=create-note v-on:submit.prevent=createNote> <input name=title v-model=title placeholder=Title /> <textarea name=content v-model=content placeholder=\"Text goes here...\" rows=3>\n  </textarea> <button type=submit>+</button> </form>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notes/Create.vue
 ** module id = 81
 ** module chunks = 0
 **/